var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"title__text"},[_vm._t("default")],2)])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }